import { BASE_CONFIG } from './base.config';
import urls from './urls.config.json';
import { AppVariants } from '@store/models';

/**
 * OCW variant configuration for all environments
 * URLs are imported from urls.config.json (single source of truth)
 */

export const OCW_CONFIG = {
  variant: AppVariants.OCW,
  clientId: 'caldst-fe-client',

  /** Mock/local development environment */
  mock: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.ocw.doorstroomtoets.mock',
      CloudRoleName: 'cito-ocw.dst-app-fe-mock',
    },
    BFF: {
      ApiUrl: urls.mock.ocw.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.mock.ocw.authUrl,
      ClientId: 'caldst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.mock.ocw.authUrl,
      ClientId: 'caldst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.mock.ocw.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'CALDST',
    },
    // Skip authentication if configured (e.g., for running locally with mocks and/or E2E testing)
    skipAuth: true,
    mockUser: {
      email: 'test@example.com',
      name: 'Test User',
      roles: ['APPBHR', 'FBH', 'TEBH'], // Add additional roles as needed for testing
    },
  },

  /** Test environment */
  test: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.ocw.doorstroomtoets',
      CloudRoleName: 'cito-ocw.dst-app-fe-o',
    },
    BFF: {
      ApiUrl: urls.ocw.test.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.ocw.test.authUrl,
      ClientId: 'caldst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.ocw.test.authUrl,
      ClientId: 'caldst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.ocw.test.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'CALDST',
    },
  },

  /** Acc environment */
  acc: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.ocw.doorstroomtoets',
      CloudRoleName: 'cito-ocw.dst-app-fe-a',
    },
    BFF: {
      ApiUrl: urls.ocw.acc.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.ocw.acc.authUrl,
      ClientId: 'caldst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.ocw.acc.authUrl,
      ClientId: 'caldst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.ocw.acc.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'CALDST',
    },
  },

  /** Production environment */
  production: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.ocw.doorstroomtoets',
      CloudRoleName: 'cito-ocw.dst-app-fe-o',
    },
    BFF: {
      ApiUrl: urls.ocw.production.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.ocw.production.authUrl,
      ClientId: 'caldst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.ocw.production.authUrl,
      ClientId: 'caldst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.ocw.production.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'CALDST',
    },
  },
};
